import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import cn from 'classnames';
import Scroller from './components/Scroller';
import Image from 'components/UI/Image';
import { getImagesWithArtDirection } from 'utils/images';

import * as styles from './Intro.module.scss';

export default function Intro({
  id = 'intro',
  background,
  imgAlt,
  Content,
  Icons,
  theme,
  size = 'md',
  scrollerKey,
  gatsbyImage,
}) {
  const images = gatsbyImage?.desktop && getImagesWithArtDirection(gatsbyImage);

  return (
    <section id={id} className={styles.wrap}>
      <div className={cn(styles.intro, theme && styles[theme], size && styles[size])}>
        {background && (
          <Image
            src={background}
            alt=""
            className={styles.picture}
            classImage={styles.pictureImage}
            lazy={false}
          />
        )}
        {gatsbyImage?.desktop && (
          <GatsbyImage
            alt={imgAlt ?? ''}
            image={images}
            loading="eager"
            className={styles.picture}
            imgClassName={styles.pictureImage}
            quality={90}
          />
        )}
        <div className={styles.content}>
          <div className={styles.contentLayout}>{Content}</div>
          {Icons}
        </div>
        {scrollerKey && <Scroller scrollerKey={scrollerKey} className={styles.scroller} />}
      </div>
    </section>
  );
}
